import { isProduction } from "@/lib/utils"

/**
 * Environment configuration with validation
 */

function validateUrl(url: string | undefined, name: string): string {
  if (!url) {
    throw new Error(`${name} is required but not defined`)
  }

  try {
    const parsed = new URL(url)
    if (!["http:", "https:"].includes(parsed.protocol)) {
      throw new Error(`${name} must use HTTP or HTTPS protocol`)
    }
    return url
  } catch (error) {
    throw new Error(`${name} is not a valid URL: ${error}`)
  }
}

function getEnvVar(key: string, required = true): string | undefined {
  const value = import.meta.env[key]

  if (required && !value) {
    throw new Error(`Environment variable ${key} is required but not defined`)
  }

  return value
}

// Validate and expose environment variables
function getApiUrl(): string {
  const url = getEnvVar("VITE_API_URL", true)
  return validateUrl(url, "VITE_API_URL")
}

// Export a singleton instance
export const env = {
  apiUrl: getApiUrl(),
  isDevelopment: !isProduction,
  isProduction: isProduction,
  mode: import.meta.env.MODE || "development",
  unleashKey: getEnvVar("VITE_UNLEASH_KEY", true) ?? "",
  sentryDsn: getEnvVar("VITE_SENTRY_DSN", false),
  release: getEnvVar("VITE_RELEASE", false),
  sentryEnvironment: getEnvVar("VITE_SENTRY_ENVIRONMENT", false),
}
